<article class="box_default box_white">
  <header>
    <h3>ADD NEW CATEGORY</h3>
  </header>
  <div class="box_main">
    <form [formGroup]="form">
      <!-- <span class="txt_error" *ngIf="errorAddStatus">{{textError}}</span> -->
      <div class="box_item">
        <label class="box-label">CATEGORY NAME</label>
          <input type="text" placeholder="Write here the name you want to assign to this category" formControlName="name"/>
      </div>
      <!-- TODO color selector -->
      <div class="box_fieldset">
        <core-helpers-forms-button-white [text]="'Save'" [disabled]="form.invalid" (click)= "add()"></core-helpers-forms-button-white>
        <core-helpers-forms-button [type]="'grey'" [text]="'Cancel'" (click)="onCancel($event)"></core-helpers-forms-button>
      </div>
    </form>
  </div>
</article>
